import Locale from 'rmc-calendar/es/locale/zh_CN';
export default Locale;